import { BTTYPE } from './binary-tree';
import { CoordinatorService } from './coordinator.service';
import { Project } from './project';
import { Report } from './report';
import { ScriptAutoUserManager } from './script-auto-user-manager';
import { ScriptHtml, TABLE_FROM_MAP_ARGS } from './script-html';
import { ScriptUserManager } from './script-user-manager';

export class ScriptProject {
    #coords: CoordinatorService;
    #project: Project | Report;

    constructor(coords: CoordinatorService, _project: Project | Report) {
        this.#coords = coords;
        this.#project = _project;
    }

    get attachments() {
        if (this.#project instanceof Project)
            return this.#coords.attachment$.attachments.map((att) => att.scriptClass);
        return [];
    }

    get databins() {
        if (this.#project instanceof Project)
            return this.#coords.databin$.sortedDatabinLs.map((d) => d.scriptClass);
        return [];
    }

    get keywords() {
        if (this.#project instanceof Project)
            return this.#coords.keyword$.sortedKeywordLs.map((kw) => kw.scriptClass);
        return this.#project.keywords;
    }

    get subsets() {
        if (this.#project instanceof Project)
            return this.#coords.view$.sortedViewLs.map((s) => s.scriptClass);
        return this.#project.subsets;
    }

    get userManager() {
        return new ScriptUserManager(this.#coords);
    }

    get autouserManager() {
        return new ScriptAutoUserManager(this.#coords);
    }

    create(type: string, title: string) {
       
        return;
    }

    #_bt(tp: BTTYPE) {
        return this.#coords.binaryTree$.getSortedList(tp).map((bt) => bt.scriptClass);
    }

    get ratings() {
        return this.#_bt('ratings');
    }

    get tags() {
        return this.#_bt('tags');
    }

    get comments() {
        return this.#coords.comment$.currentUserCommentLs.map((c) => c.scriptClass);
    }

    reset({
        keywords,
        keywordGroups,
        ratings,
        tags,
    }: {
        keywords: boolean;
        keywordGroups: boolean;
        ratings: boolean;
        tags: boolean;
    }) {
        if (keywords) this.#coords.keyword$.clear(false);
        if (keywordGroups) this.#coords.keyword$.clearGroups();

        if (keywords || keywordGroups) {
            this.#coords.highlight$.reset();
            this.#coords.keyword$.markForManifestStore();
        }

        if (ratings) this.#coords.binaryTree$.reset('ratings');
        if (tags) this.#coords.binaryTree$.reset('tags');

        this.#coords.display$.markForCheck();
        return this;
    }

    databin(title: string, isCreate = false) {
        let dtb = this.#coords.databin$.getByTitle(title);
        if (!dtb) {
            if (!isCreate) return null;
            dtb = this.#coords.databin$.new({ title });
        }

        return dtb.scriptClass;
    }

    json() {
        return this.#project.json();
    }

    getValue(tag: string) {
        return this.#project.get(tag);
    }

    setValue(tag: string, val: any) {
        this.#project.set(tag, val);
    }

    html(tp: TABLE_FROM_MAP_ARGS = 'all') {
        const h = new ScriptHtml(this.#coords);
        return h.tableFromMap(tp, this.#project.valueMap);
    }

    log(prefix = 'Project') {
        console.log(`${prefix}: ${this.#project.title}`);
        return this;
    }

    batch(tag: string, params: any) {
        this.#coords.batch$.runNamedBatch(tag, params);
    }

    get shareLink() {
        return (this.#project as Project).shareLink;
    }

    display = this.log;
}
